import axios from 'axios'
import Qs from 'qs'
import ls from './localStorage.js'
// axios 配置
axios.defaults.timeout = 10000;
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
// axios.defaults.withCredentials = true;
// axios.interceptors.response.use(res => {
//     return res.data
// })

// //Axios实现请求重试
// axios.defaults.retry = 2; //重试次数
// axios.defaults.retryDelay = 1000; //重试延时
// axios.defaults.shouldRetry = (error) => true; //重试条件，默认只要是错误都需要重试

// 返回错误时拦截，并尝试重试
axios.interceptors.response.use(undefined, function (err) {
  var config = err.config
  // 判断是否配置了重试
  if (!config || !config.retry) return Promise.reject(err)

  if (!config.shouldRetry || typeof config.shouldRetry !== 'function') return Promise.reject(err)

  // 判断是否满足重试条件
  if (!config.shouldRetry(err)) return Promise.reject(err)

  // 设置重试次数
  config.__retryCount = config.__retryCount || 0
  if (config.__retryCount >= config.retry) return Promise.reject(err)

  // 重试次数自增
  config.__retryCount += 1

  // 延时处理
  var backoff = new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, config.retryDelay || 1);
  });

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    return axios(config);
  });

  // post(config.url, config.data).then(res => {
  //   //console.log(res)
  // })


})



const globalData = {
  postSuc: 200,
  entry: 'index', //默认视图文件名
  engine: '.html', //视图文件后缀名
  pageTabs: false, //是否开启页面选项卡功能。单页版不推荐开启
  name: 'CHAT',
  tableName: 'layuiAdmin', //本地存储表名
  MOD_NAME: 'admin', //模块事件名
  debug: true, //是否开启调试模式。如开启，接口异常时会抛出异常 URL 等信息
  interceptor: true, //是否开启未登入拦截
  ctx: 'https://chat.msforex.com/az_message_port/',//正式
  customCtx:'https://www.msforex.com/site-admin/',
  imgHead: 'https://chat.msforex.com/upload',
  //自定义请求字段
  request: {
    username: 'username', //用户名
    password: 'password', //密码
    tokenName: 'token', //自动携带 token 的字段名。可设置 false 不携带。
    userId: 'userId'
  },
}


const post = function (url, data,isCustomer) {
  // data = JSON.parse(data);
  return new Promise((resolve, reject) => {
    data.token = ls.getItem("token");
    data = Qs.stringify(data);
    url = `${globalData.ctx}${url}`;
    // isCustomer?url = `${globalData.customCtx}${url}`:url = `${globalData.ctx}${url}`;
    axios({
      method: "post",
      url: url,
      data: data,
      retry: 2,
      retryDelay: 1000,
      shouldRetry: (error) => true
    }).then(function (res) {
      //console.log(`接口返回数据`, res);
      resolve(res)

    }).catch(function (error) {
      //console.log(error);
      reject(error)
    })
  })
}


const get = function (url, data,isCustomer) {
  return new Promise((resolve, reject) => {
    isCustomer?url = `${globalData.customCtx}${url}`: url = `${globalData.ctx}${url}`;
    axios({
      method: "get",
      url:url,
      data: data
    }).then(function (res) {
      //console.log(`接口返回数据`, res);
      resolve(res)

    }).catch(function (error) {
      //console.log(error);
    })
  })
}


const upload = function (data) {
  return new Promise((resolve, reject) => {
    // isCustomer?url = `${globalData.customCtx}${url}`: url = `${globalData.ctx}${url}`;
    axios({
      method: "post",
      url: `${globalData.ctx}/webMsg/uploadFile`,
      data: data,
      headers:{'Content-Type': 'multipart/form-data'},
      retry: 2,
      retryDelay: 1000,
      shouldRetry: (error) => true
    }).then(function (res) {
      //console.log(`接口返回数据`, res);
      resolve(res)
    }).catch(function (error) {
      //console.log(error);
    })
  })
}



const formatDate = function (now) {
  var year = now.getFullYear();
  var month = now.getMonth() + 1;
  var date = now.getDate();
  var hour = now.getHours();
  var minute = now.getMinutes();
  var second = now.getSeconds();
  if (month < 10) {
    month = "0" + month;
  }
  if (date < 10) {
    date = "0" + date;
  }
  if (hour < 10) {
    hour = "0" + hour;
  }
  if (minute < 10) {
    minute = "0" + minute;
  }
  if (second < 10) {
    second = "0" + second;
  }
  return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
}



export default {
  globalData,
  post,
  get,
  formatDate,
  upload
}



// WEBPACK FOOTER //
// ./src/common/global.js